export const CREATE_BASIC_DETAIL = "CREATE_BASIC_DETAIL";
export const FETCH_BASIC_DETAILS = "FETCH_BASIC_DETAILS";
export const FETCH_BASIC_DETAIL = "FETCH_BASIC_DETAIL";
export const EDIT_BASIC_DETAIL = "EDIT_BASIC_DETAIL";
export const DELETE_BASIC_DETAIL = "DELETE_BASIC_DETAIL";
